module.exports = {"371426001":"龙门街道","371426002":"桃园街道","371426101":"王凤楼镇","371426102":"前曹镇","371426103":"恩城镇","371426104":"王庙镇","371426105":"王杲铺镇","371426106":"张华镇","371426107":"腰站镇","371426108":"王打卦镇","371426200":"坊子乡","371426202":"三唐乡","371426400":"平原县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371426.json
// module id = 1478
// module chunks = 0